import Vue from 'vue'
import {
  ThisTypedComponentOptionsWithArrayProps,
  WatchOptions,
} from 'vue/types/options'

export function createModelPlus<T extends Record<any, any>>(initialState: T) {
  const state = new Vue(
    Object.keys(initialState).reduce(
      (res, key) => {
        const descriptor = Object.getOwnPropertyDescriptor(initialState, key)
        if (descriptor) {
          const getter = descriptor.get
          if (getter) {
            const setter = descriptor.set
            ;(res.computed as any)[key] = setter
              ? {
                  get() {
                    return getter.call(this)
                  },
                  set(v: any) {
                    return setter.call(this, v)
                  },
                }
              : function (this: any) {
                  return getter.call(this)
                }
          } else {
            const value = descriptor.value
            if (typeof value === 'function') {
              ;(res.methods as any)[key] = value
            } else {
              ;(res.data as any)[key] = value
            }
          }
        }
        return res
      },
      {
        created() {
          Object.defineProperty(this, '$mixin', {
            value: {
              created() {
                Object.defineProperty(this, '$state', {
                  value: state,
                })
              },
            },
          })
        },
        data: {},
        computed: {},
        watch: {},
        methods: {
          $update(nextState: Partial<T>) {
            Object.assign(state, nextState)
          },
          $reset() {
            Object.assign(state, initialState)
          },
          $beforeDestroy(cb: any) {
            this.$once('hook:beforeDestroy', cb)
          },
          $watchResolveOnFirstTrigger(exp: any, cb: any, options: any) {
            return new Promise<void>(resolve => {
              this.$watch(
                exp,
                async () => {
                  await cb()
                  resolve()
                },
                options,
              )
            })
          },
        },
      } as ThisTypedComponentOptionsWithArrayProps<
        Vue,
        object,
        object,
        object,
        never
      >,
    ),
  )
  return state as any as T & {
    $update: (nextState: Partial<T>) => any
    $reset: () => any
    $mixin: Record<any, any>
    $watch: (exp: () => any, cb: () => any, options?: WatchOptions) => any
    $watchResolveOnFirstTrigger: (
      exp: () => any,
      cb: () => any,
      options?: WatchOptions,
    ) => Promise<any>
    $destroy: () => any
    $beforeDestroy: (cb: () => any) => any
  }
}
